import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, LOCALE_ID } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideNavigation } from '@rms/core/navigation';
import { provideLayout } from '@rms/layout';

import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { customLoaderFactory } from './core/http/translation.loader';
import { provideIcons } from './core/icons/icons.provider';
import { provideLuxon, provideRmsLuxonDateAdapter } from './core/luxon/luxon.provider';
import { provideNotifications } from './core/notification/notification.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: environment.defaultLanguage },
    importProvidersFrom(
      BrowserModule,
      MatDialogModule,
      TranslateModule.forRoot({
        fallbackLang: environment.defaultLanguage,
        loader: { provide: TranslateLoader, useFactory: customLoaderFactory },
      })
    ),
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { hasBackdrop: true, disableClose: true, closeOnNavigation: true, autoFocus: false },
    },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
    provideRouter(
      appRoutes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' })
    ),
    provideAnimations(),
    provideHttpClient(),
    provideLayout(),
    provideNavigation(),
    provideIcons(),
    provideNotifications(),
    provideLuxon(),
    provideRmsLuxonDateAdapter(),
  ],
};
